/*
 *  Before/After Sliders
 *   Scripts for the before/after image sliders
 *   Based on this codepen https://codepen.io/dudleystorey/pen/DJqNKP
 *
 *  Version:
 *    1.0.0 - 2022/03/14
 */

const SELECTOR_SLIDER_CONTAINER = '[data-before-after-image-container]';
const SELECTOR_SLIDER_DIVISOR = '[data-image-slider-divisor]';
const SELECTOR_SLIDER_HANDLE = '[data-image-slider-handle]';
const SELECTOR_SLIDER_RANGE = '[data-image-slider-range]';

const body = document.body;

document
  .querySelectorAll<HTMLElement>(SELECTOR_SLIDER_CONTAINER)
  .forEach((sliderContainer) => {
    const divisor = sliderContainer.querySelector<HTMLElement>(
      SELECTOR_SLIDER_DIVISOR
    );
    const handle = sliderContainer.querySelector<HTMLElement>(
      SELECTOR_SLIDER_HANDLE
    );
    const slider = sliderContainer.querySelector<HTMLInputElement>(
      SELECTOR_SLIDER_RANGE
    );

    if (!divisor || !handle || !slider) return;

    const moveDivisor = () => {
      handle.style.left = `${slider.value}%`;
      divisor.style.width = `${slider.value}%`;
    };

    slider.addEventListener('input', () => {
      // added because whole page was moving
      body.style.overflowX = 'hidden';
      sliderContainer.style.cursor = 'grabbing';
      moveDivisor();
    });

    slider.addEventListener('mouseup', () => {
      body.style.overflowX = 'revert';
      sliderContainer.style.cursor = 'grab';
    });

    window.onload = () => {
      moveDivisor();
    };
  });
